<template>
  <div class="container">
    <el-select v-model="project_name"  @change="handleProjectChange" placeholder="请选择" style="width: 500px;">
      <el-option v-for="item in project_name_options" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
    <hr>
    <table class="styled-table">
      <tr>
        <td>场所总数量</td>
        <td>{{ formData.site_amount_number }}</td>
        <td>项目总人数</td>
        <td>{{ formData.total_employees }}</td>
      </tr>
      <tr>
        <td>出租屋总数量</td>
        <td>{{ formData.czw_number }}</td>
        <td>三小场所总数量</td>
        <td>{{ formData.sx_number }}</td>
        <td>其他场所总数量</td>
        <td>{{ formData.other_number }}</td>
      </tr>
      <tr>
        <td>昨日已完成检测数量</td>
        <td>{{ formData.today_ywc_count }}</td>
      </tr>
      <tr>
        <td>昨日已完成出租屋检测数量</td>
        <td>{{ formData.today_ywc_czw_count }}</td>
        <td>昨日已完成三小检测数量</td>
        <td>{{ formData.today_ywc_sx_count }}</td>
        <td>昨日已完成其他场所检测数量</td>
        <td>{{ formData.today_ywc_other_count }}</td>
      </tr>
      <tr>
        <td>昨日已完成复检数量</td>
        <td>{{ formData.today_ywc_fj_count }}</td>
      </tr>
      <tr>
        <td>昨日已完成出租屋复检数量</td>
        <td>{{ formData.today_ywc_czw_fj_count }}</td>
        <td>昨日已完成三小复检数量</td>
        <td>{{ formData.today_ywc_sx_fj_count }}</td>
        <td>昨日已完成其他场所复检数量</td>
        <td>{{ formData.today_ywc_other_fj_count }}</td>
      </tr>
      <tr>
        <td>昨日cma版隐患总数量</td>
        <td>{{ formData.today_cma_count }}</td>
      </tr>
      <tr>
        <td>昨日cma版出租屋隐患数量</td>
        <td>{{ formData.today_cma_czw_count }}</td>
        <td>昨日cma版三小隐患数量</td>
        <td>{{ formData.today_cma_sx_count }}</td>
        <td>昨日cma版其他场所隐患数量</td>
        <td>{{ formData.today_cma_other_count }}</td>
      </tr>
      <tr>
        <td>昨日直观版隐患总数量</td>
        <td>{{ formData.today_zg_count }}</td>
      </tr>
      <tr>
        <td>昨日直观版出租屋隐患数量</td>
        <td>{{ formData.today_zg_czw_count }}</td>
        <td>昨日直观版三小隐患数量</td>
        <td>{{ formData.today_zg_sx_count }}</td>
        <td>昨日直观版其他场所隐患数量</td>
        <td>{{ formData.today_zg_other_count }}</td>
      </tr>
      <tr>
        <td>总体已完成检测数量</td>
        <td>{{ formData.summary_ywc_count }}</td>
      </tr>
      <tr>
        <td>总体已完成出租屋检测数量</td>
        <td>{{ formData.summary_ywc_czw_count }}</td>
        <td>总体已完成三小检测数量</td>
        <td>{{ formData.summary_ywc_sx_count }}</td>
        <td>总体已完成其他场所检测数量</td>
        <td>{{ formData.summary_ywc_other_count }}</td>
      </tr>
      <tr>
        <td>总体已完成复检数量</td>
        <td>{{ formData.summary_ywc_fj_count }}</td>
      </tr>
      <tr>
        <td>总体已完成出租屋复检数量</td>
        <td>{{ formData.summary_ywc_fj_czw_count }}</td>
        <td>总体已完成三小复检数量</td>
        <td>{{ formData.summary_ywc_fj_sx_count }}</td>
        <td>总体已完成其他场所复检数量</td>
        <td>{{ formData.summary_ywc_fj_other_count }}</td>
      </tr>
      <tr>
        <td>总体检测中数量</td>
        <td>{{ formData.summary_jcz_count }}</td>
      </tr>
      <tr>
        <td>总体检测中出租屋数量</td>
        <td>{{ formData.summary_jcz_czw_count }}</td>
        <td>总体检测中三小数量</td>
        <td>{{ formData.summary_jcz_sx_count }}</td>
        <td>总体检测中其他场所数量</td>
        <td>{{ formData.summary_jcz_other_count }}</td>
      </tr>
      <tr>
        <td>总体无检测数量</td>
        <td>{{ formData.summary_wjc_count }}</td>
      </tr>
      <tr>
        <td>总体无检测出租屋数量</td>
        <td>{{ formData.summary_wjc_czw_count }}</td>
        <td>总体无检测三小数量</td>
        <td>{{ formData.summary_wjc_sx_count }}</td>
        <td>总体无检测其他场所数量</td>
        <td>{{ formData.summary_wjc_other_count }}</td>
      </tr>
      <tr>
        <td>总体完成率</td>
        <td>{{ formData.summary_completion_rate }}%</td>
      </tr>
      <tr>
        <td>总体出租屋完成率</td>
        <td>{{ formData.summary_completion_czw_rate }}%</td>
        <td>总体三小完成率</td>
        <td>{{ formData.summary_completion_sx_rate }}%</td>
        <td>总体其他场所完成率</td>
        <td>{{ formData.summary_completion_other_rate }}%</td>
      </tr>
      <tr>
        <td>总体cma总数量</td>
        <td>{{ formData.summary_cma_count }}</td>
      </tr>
      <tr>
        <td>总体cma出租屋数量</td>
        <td>{{ formData.summary_cma_czw_count }}</td>
        <td>总体cma三小数量</td>
        <td>{{ formData.summary_cma_sx_count }}</td>
        <td>总体cma其他场所数量</td>
        <td>{{ formData.summary_cma_other_count }}</td>
      </tr>
      <tr>
        <td>总体cma已整改数量</td>
        <td>{{ formData.summary_cma_yzg_count }}</td>
      </tr>
      <tr>
        <td>总体cma出租屋已整改数量</td>
        <td>{{ formData.summary_cma_yzg_czw_count }}</td>
        <td>总体cma三小已整改数量</td>
        <td>{{ formData.summary_cma_yzg_sx_count }}</td>
        <td>总体cma其他场所已整改数量</td>
        <td>{{ formData.summary_cma_yzg_other_count }}</td>
      </tr>

      <tr>
        <td>总体cma版A级数量</td>
        <td>{{ formData.summary_cma_a_count }}</td>
      </tr>
      <tr>
        <td>总体cma版A级出租屋数量</td>
        <td>{{ formData.summary_cma_a_czw_count }}</td>
        <td>总体cma版A级三小数量</td>
        <td>{{ formData.summary_cma_a_sx_count }}</td>
        <td>总体cma版A级其他场所数量</td>
        <td>{{ formData.summary_cma_a_other_count }}</td>
      </tr>
      <tr>
        <td>总体cma版A级已整改数量</td>
        <td>{{ formData.summary_cma_a_yzg_count }}</td>
      </tr>
      <tr>
        <td>总体出租屋cma版A级已整改数量</td>
        <td>{{ formData.summary_cma_a_yzg_czw_count }}</td>
        <td>总体三小cma版A级已整改数量</td>
        <td>{{ formData.summary_cma_a_yzg_sx_count }}</td>
        <td>总体其他场所cma版A级已整改数量</td>
        <td>{{ formData.summary_cma_a_yzg_other_count }}</td>
      </tr>

      <tr>
        <td>总体cma版B级数量</td>
        <td>{{ formData.summary_cma_b_count }}</td>
      </tr>
      <tr>
        <td>总体cma版B级出租屋数量</td>
        <td>{{ formData.summary_cma_b_czw_count }}</td>
        <td>总体cma版B级三小数量</td>
        <td>{{ formData.summary_cma_b_sx_count }}</td>
        <td>总体cma版B级其他场所数量</td>
        <td>{{ formData.summary_cma_b_other_count }}</td>
      </tr>

      <tr>
        <td>总体cma版B级已整改数量</td>
        <td>{{ formData.summary_cma_b_yzg_count }}</td>
      </tr>
      <tr>
        <td>总体出租屋cma版B级已整改数量</td>
        <td>{{ formData.summary_cma_b_yzg_czw_count }}</td>
        <td>总体三小cma版B级已整改数量</td>
        <td>{{ formData.summary_cma_b_yzg_sx_count }}</td>
        <td>总体其他场所cma版B级已整改数量</td>
        <td>{{ formData.summary_cma_b_yzg_other_count }}</td>
      </tr>

      <tr>
        <td>总体cma版C级数量</td>
        <td>{{ formData.summary_cma_c_count }}</td>
      </tr>
      <tr>
        <td>总体cma版C级出租屋数量</td>
        <td>{{ formData.summary_cma_c_czw_count }}</td>
        <td>总体cma版C级三小数量</td>
        <td>{{ formData.summary_cma_c_sx_count }}</td>
        <td>总体cma版C级其他场所数量</td>
        <td>{{ formData.summary_cma_c_other_count }}</td>
      </tr>

      <tr>
        <td>总体cma版C级已整改数量</td>
        <td>{{ formData.summary_cma_c_yzg_count }}</td>
      </tr>
      <tr>
        <td>总体出租屋cma版C级已整改数量</td>
        <td>{{ formData.summary_cma_c_yzg_czw_count }}</td>
        <td>总体三小cma版C级已整改数量</td>
        <td>{{ formData.summary_cma_c_yzg_sx_count }}</td>
        <td>总体其他场所cma版C级已整改数量</td>
        <td>{{ formData.summary_cma_c_yzg_other_count }}</td>
      </tr>

      <tr>
        <td>总体直观版数量</td>
        <td>{{ formData.summary_zg_count }}</td>
      </tr>
      <tr>
        <td>总体直观版出租屋数量</td>
        <td>{{ formData.summary_zg_czw_count }}</td>
        <td>总体直观版三小数量</td>
        <td>{{ formData.summary_zg_sx_count }}</td>
        <td>总体直观版其他场所数量</td>
        <td>{{ formData.summary_zg_other_count }}</td>
      </tr>

      <tr>
        <td>总体直观版已整改数量</td>
        <td>{{ formData.summary_zg_yzg_count }}</td>
      </tr>
      <tr>
        <td>总体出租屋直观版已整改数量</td>
        <td>{{ formData.summary_zg_yzg_czw_count }}</td>
        <td>总体三小直观版已整改数量</td>
        <td>{{ formData.summary_zg_yzg_sx_count }}</td>
        <td>总体其他场所直观版已整改数量</td>
        <td>{{ formData.summary_zg_yzg_other_count }}</td>
      </tr>

      <tr>
        <td>总体直观版A级数量</td>
        <td>{{ formData.summary_zg_a_count }}</td>
      </tr>
      <tr>
        <td>总体直观版A级出租屋数量</td>
        <td>{{ formData.summary_zg_a_czw_count }}</td>
        <td>总体直观版A级三小数量</td>
        <td>{{ formData.summary_zg_a_sx_count }}</td>
        <td>总体直观版A级其他场所数量</td>
        <td>{{ formData.summary_zg_a_other_count }}</td>
      </tr>

      <tr>
        <td>总体直观版A级已整改数量</td>
        <td>{{ formData.summary_zg_a_yzg_count }}</td>
      </tr>
      <tr>
        <td>总体出租屋直观版A级已整改数量</td>
        <td>{{ formData.summary_zg_a_yzg_czw_count }}</td>
        <td>总体三小直观版A级已整改数量</td>
        <td>{{ formData.summary_zg_a_yzg_sx_count }}</td>
        <td>总体其他场所直观版A级已整改数量</td>
        <td>{{ formData.summary_zg_a_yzg_other_count }}</td>
      </tr>

      <tr>
        <td>总体直观版B级数量</td>
        <td>{{ formData.summary_zg_b_count }}</td>
      </tr>
      <tr>
        <td>总体直观版B级出租屋数量</td>
        <td>{{ formData.summary_zg_b_czw_count }}</td>
        <td>总体直观版B级三小数量</td>
        <td>{{ formData.summary_zg_b_sx_count }}</td>
        <td>总体直观版B级其他场所数量</td>
        <td>{{ formData.summary_zg_b_other_count }}</td>
      </tr>

      <tr>
        <td>总体直观版B级已整改数量</td>
        <td>{{ formData.summary_zg_b_yzg_count }}</td>
      </tr>
      <tr>
        <td>总体出租屋直观版B级已整改数量</td>
        <td>{{ formData.summary_zg_b_yzg_czw_count }}</td>
        <td>总体三小直观版B级已整改数量</td>
        <td>{{ formData.summary_zg_b_yzg_sx_count }}</td>
        <td>总体其他场所直观版B级已整改数量</td>
        <td>{{ formData.summary_zg_b_yzg_other_count }}</td>
      </tr>

      <tr>
        <td>总体直观版C级数量</td>
        <td>{{ formData.summary_zg_c_count }}</td>
      </tr>
      <tr>
        <td>总体直观版C级出租屋数量</td>
        <td>{{ formData.summary_zg_c_czw_count }}</td>
        <td>总体直观版C级三小数量</td>
        <td>{{ formData.summary_zg_c_sx_count }}</td>
        <td>总体直观版C级其他场所数量</td>
        <td>{{ formData.summary_zg_c_other_count }}</td>
      </tr>

      <tr>
        <td>总体直观版C级已整改数量</td>
        <td>{{ formData.summary_zg_c_yzg_count }}</td>
      </tr>
      <tr>
        <td>总体出租屋直观版C级已整改数量</td>
        <td>{{ formData.summary_zg_c_yzg_czw_count }}</td>
        <td>总体三小直观版C级已整改数量</td>
        <td>{{ formData.summary_zg_c_yzg_sx_count }}</td>
        <td>总体其他场所直观版C级已整改数量</td>
        <td>{{ formData.summary_zg_c_yzg_other_count }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        'site_amount_number': 0,//场所总数量
        'total_employees': 0,//项目总人数

        'czw_number': 0,//出租屋总数量
        'sx_number': 0,//三小场所总数量
        'other_number': 0,//其他场所总数量

        'today_ywc_count': 0,//昨日已完成检测数量
        'today_ywc_czw_count': 0,//昨日已完成出租屋检测数量
        'today_ywc_sx_count': 0,//昨日已完成三小检测数量
        'today_ywc_other_count': 0,//昨日已完成其他场所检测数量

        'today_ywc_fj_count': 0,//昨日已完成复检数量
        'today_ywc_czw_fj_count': 0,//昨日已完成出租屋复检数量
        'today_ywc_sx_fj_count': 0,//昨日已完成三小复检数量
        'today_ywc_other_fj_count': 0,//昨日已完成其他场所复检数量

        'today_cma_count': 0,//昨日cma版隐患总数量
        'today_cma_czw_count': 0,//昨日cma版出租屋隐患数量
        'today_cma_sx_count': 0,//昨日cma版三小隐患数量
        'today_cma_other_count': 0,//昨日cma版其他场所隐患数量

        'today_zg_count': 0,//昨日直观版隐患总数量
        'today_zg_czw_count': 0,//昨日直观版出租屋隐患数量
        'today_zg_sx_count': 0,//昨日直观版三小隐患数量
        'today_zg_other_count': 0,//昨日直观版其他场所隐患数量

        'summary_ywc_count': 0,//总体已完成检测数量
        'summary_ywc_czw_count': 0,//总体已完成出租屋检测数量
        'summary_ywc_sx_count': 0,//总体已完成三小检测数量
        'summary_ywc_other_count': 0,//总体已完成其他场所检测数量

        'summary_ywc_fj_count': 0,//总体已完成复检数量
        'summary_ywc_fj_czw_count': 0,//总体已完成出租屋复检数量
        'summary_ywc_fj_sx_count': 0,//总体已完成三小复检数量
        'summary_ywc_fj_other_count': 0,//总体已完成其他场所复检数量

        'summary_jcz_count': 0,//总体检测中数量
        'summary_jcz_czw_count': 0,//总体检测中出租屋数量
        'summary_jcz_sx_count': 0,//总体检测中三小数量
        'summary_jcz_other_count': 0,//总体检测中其他场所数量

        'summary_wjc_count': 0,//总体无检测数量
        'summary_wjc_czw_count': 0,//总体无检测出租屋数量
        'summary_wjc_sx_count': 0,//总体无检测三小数量
        'summary_wjc_other_count': 0,//总体无检测其他场所数量

        'summary_completion_rate': 0,//总体完成率
        'summary_completion_czw_rate': 0,//总体出租屋完成率
        'summary_completion_sx_rate': 0,//总体三小完成率
        'summary_completion_other_rate': 0,//总体其他场所完成率

        'summary_cma_count': 0,//总体cma总数量
        'summary_cma_czw_count': 0,//总体cma出租屋数量
        'summary_cma_sx_count': 0,//总体cma三小数量
        'summary_cma_other_count': 0,//总体cma其他场所数量

        'summary_cma_yzg_count': 0,//总体cma已整改数量
        'summary_cma_yzg_czw_count': 0,//总体cma出租屋已整改数量
        'summary_cma_yzg_sx_count': 0,//总体cma三小已整改数量
        'summary_cma_yzg_other_count': 0,//总体cma其他场所已整改数量

        'summary_cma_a_count': 0,//总体cma版A级数量
        'summary_cma_a_czw_count': 0,//总体cma版A级出租屋数量
        'summary_cma_a_sx_count': 0,//总体cma版A级三小数量
        'summary_cma_a_other_count': 0,//总体cma版A级其他场所数量

        'summary_cma_a_yzg_count': 0,//总体cma版A级已整改数量
        'summary_cma_a_yzg_czw_count': 0,//总体cma版A级出租屋已整改数量
        'summary_cma_a_yzg_sx_count': 0,//总体cma版A级三小已整改数量
        'summary_cma_a_yzg_other_count': 0,//总体cma版A级其他场所已整改数量

        'summary_cma_b_count': 0,//总体cma版B级数量
        'summary_cma_b_czw_count': 0,//总体cma版B级出租屋数量
        'summary_cma_b_sx_count': 0,//总体cma版B级三小数量
        'summary_cma_b_other_count': 0,//总体cma版B级其他场所数量

        'summary_cma_b_yzg_count': 0,//总体cma版B级已整改数量
        'summary_cma_b_yzg_czw_count': 0,//总体cma版B级出租屋已整改数量
        'summary_cma_b_yzg_sx_count': 0,//总体cma版B级三小已整改数量
        'summary_cma_b_yzg_other_count': 0,//总体cma版B级其他场所已整改数量

        'summary_cma_c_count': 0,//总体cma版C级数量
        'summary_cma_c_czw_count': 0,//总体cma版C级出租屋数量
        'summary_cma_c_sx_count': 0,//总体cma版C级三小数量
        'summary_cma_c_other_count': 0,//总体cma版C级其他场所数量

        'summary_cma_c_yzg_count': 0,//总体cma版C级已整改数量
        'summary_cma_c_yzg_czw_count': 0,//总体cma版C级出租屋已整改数量
        'summary_cma_c_yzg_sx_count': 0,//总体cma版C级三小已整改数量
        'summary_cma_c_yzg_other_count': 0,//总体cma版C级其他场所已整改数量

        'summary_zg_count': 0,//总体直观版数量
        'summary_zg_czw_count': 0,//总体直观版出租屋数量
        'summary_zg_sx_count': 0,//总体直观版三小数量
        'summary_zg_other_count': 0,//总体直观版其他场所数量

        'summary_zg_yzg_count': 0,//总体直观版已整改数量
        'summary_zg_yzg_czw_count': 0,//总体直观版出租屋已整改数量
        'summary_zg_yzg_sx_count': 0,//总体直观版三小已整改数量
        'summary_zg_yzg_other_count': 0,//总体直观版其他场所已整改数量

        'summary_zg_a_count': 0,//总体直观版A级数量
        'summary_zg_a_czw_count': 0,//总体直观版A级出租屋数量
        'summary_zg_a_sx_count': 0,//总体直观版A级三小数量
        'summary_zg_a_other_count': 0,//总体直观版A级其他场所数量

        'summary_zg_a_yzg_count': 0,//总体直观版A级已整改数量
        'summary_zg_a_yzg_czw_count': 0,//总体直观版A级出租屋已整改数量
        'summary_zg_a_yzg_sx_count': 0,//总体直观版A级三小已整改数量
        'summary_zg_a_yzg_other_count': 0,//总体直观版A级其他场所已整改数量

        'summary_zg_b_count': 0,//总体直观版B级数量
        'summary_zg_b_czw_count': 0,//总体直观版B级出租屋数量
        'summary_zg_b_sx_count': 0,//总体直观版B级三小数量
        'summary_zg_b_other_count': 0,//总体直观版B级其他场所数量

        'summary_zg_b_yzg_count': 0,//总体直观版B级已整改数量
        'summary_zg_b_yzg_czw_count': 0,//总体直观版B级出租屋已整改数量
        'summary_zg_b_yzg_sx_count': 0,//总体直观版B级三小已整改数量
        'summary_zg_b_yzg_other_count': 0,//总体直观版B级其他场所已整改数量

        'summary_zg_c_count': 0,//总体直观版C级数量
        'summary_zg_c_czw_count': 0,//总体直观版C级出租屋数量
        'summary_zg_c_sx_count': 0,//总体直观版C级三小数量
        'summary_zg_c_other_count': 0,//总体直观版C级其他场所数量

        'summary_zg_c_yzg_count': 0,//总体直观版C级已整改数量
        'summary_zg_c_yzg_czw_count': 0,//总体直观版C级出租屋已整改数量
        'summary_zg_c_yzg_sx_count': 0,//总体直观版C级三小已整改数量
        'summary_zg_c_yzg_other_count': 0,//总体直观版C级其他场所已整改数量
      },
      project_name: '',
      project_name_options: []
    };
  },
  methods: {
    handleProjectChange() {
      this.getStatistics();
    },
    async getOptions() {
      let res = await this.$Api.get('get_project_names');
      if (res) {
        this.project_name_options = res;
      }
    },
    async getStatistics() {
      try {
        let res = await this.$Api.post('get_stat_project', { project_name: this.project_name });
        if (res) {
          this.formData = res;
        }
      } catch (e) {
        this.$message.error(e.errormsg);
      }
    },
  },
  created() {
    this.getOptions();
    this.getStatistics();
  }
};
</script>
<style scoped>
.styled-table {
  border-collapse: collapse;
  width: 100%;
}

.styled-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.styled-table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.styled-table tr:hover {
  background-color: #ddd;
}
</style>